import { Route, Routes } from "react-router-dom";
import { DeckPage } from "./DeckPage";

export function CapitalIndexNotFound() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-blue-950 text-slate-200">
      <div className="text-center">
        <p className="mb-2 text-sm uppercase tracking-[0.2em] text-slate-400">404</p>
        <p className="text-lg">No deck specified.</p>
      </div>
    </div>
  );
}

export function CapitalRouter() {
  return (
    <Routes>
      <Route index element={<CapitalIndexNotFound />} />
      <Route path=":round/:deckSlug/:version?" element={<DeckPage />} />
      <Route path="*" element={<CapitalIndexNotFound />} />
    </Routes>
  );
}
